import { COMPRESS_IMAGE } from '../Common/Constants/ComponentType';
import { DeleteIcon, RotateIcon } from './Icons';

const ImageToPdfPreview = (props) => {    
    return (<div key={props.file.id} className="image-thumbnail-item-itp">
        <img src={props.file.preview} alt="Preview" className="thumbnail-img-itp" style={{ transform: `rotate(${props.file.rotation}deg)` }} />
        <p className="pdf-name" title={props.file.name}>{props.file.name}</p>
        <div className="thumbnail-actions-itp">
            <button onClick={() => props.handleRotate(props.file.id)} title="Rotate Image" className="rotate-btn">
                <RotateIcon />
            </button>
            <button onClick={() => props.handleRemove(props.file.id)} title="Remove Image" className="rotate-btn">
                <DeleteIcon />
            </button>
        </div>
    </div>)
}

const renderComponent = (file, handleRotate, handleRemove, isGenerating, componentType) => {
    switch (componentType) {
        case COMPRESS_IMAGE:            
            return <ImageToPdfPreview
                file={file}
                handleRotate={handleRotate}
                handleRemove={handleRemove}
                isGenerating={isGenerating}
            />
        default:
            return <></>

    }
}

const Preview = (props) => {
    return (<>
        {
            renderComponent
                (
                    props.file
                    , props.handleRotate
                    , props.handleRemove
                    , props.isGenerating
                    , props.componentType
                )
        }
    </>
    )
}

export default Preview;